export var PartialPaths;

(function (PartialPaths) {
  PartialPaths["List"] = "/comments";
  PartialPaths["Create"] = "/comments";
  PartialPaths["Update"] = "/comments/:commentId";
  PartialPaths["Delete"] = "/comments/:commentId";
  PartialPaths["Show"] = "/comments/:commentId";
  PartialPaths["Like"] = "/comments/:commentId/like";
  PartialPaths["Unlike"] = "/comments/:commentId/like";
  PartialPaths["ListReplies"] = "/comments/:commentId/replies";
})(PartialPaths || (PartialPaths = {}));